import React, { useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { default_design } from '../../static/default_design';
import { PentaName } from '../Penta/PentaName';
import { PentaYoni } from '../Penta/PentaYoni';
import { PublicSocial } from '../PublicSocial';
import Social from '../Social';
import { Avatar } from '../UiKit/Avatar';
import { Button } from '../UiKit/Button';
import { PentaShare } from '../UiKit/PentaShare';
import { Pop } from '../UiKit/Pop';
import { Topbar } from '../UiKit/Topbar';
import { YoniBackground } from '../UiKit/YoniBackground';
import { applyPentaMemberOrder } from '../utilsPenta';
import { applyDesignTheme, applyYoniBlackBackground, parseAvatar } from '../utilsDesign';
import { getLastDesignForTheme } from '../theme';
import { VideoPop } from '../VideoPop';
import { Study } from './Study';
import '../UiKit/Jyotish/yoni.css';

const getHashParams = (hash = window.location.hash) =>
  new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);

const processPenta = (penta) => {
  const ordered = applyPentaMemberOrder(penta);
  const { members, ...rest } = ordered;
  return {
    ...JSON.parse(JSON.stringify(rest)),
    members: (members || []).map(userAvatar => ({
      ...userAvatar,
      avatar: parseAvatar({
        ...userAvatar.avatar,
        design: userAvatar.avatar?.design?.profile ? userAvatar.avatar.design : default_design
      })
    }))
  };
};

export function YoniPentaView(props) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;

  const { penta } = { ...props };

  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [pentaInner, setPentaInner] = useState(processPenta(penta));
  const [sharePop, setSharePop] = useState(false);
  const scrollable = useRef(null);

  useEffect(() => {
    document.body.classList.add('b--yoni');
    applyYoniBlackBackground();
    return () => {
      document.body.classList.remove('b--yoni');
      applyDesignTheme(getLastDesignForTheme());
    };
  }, []);

  useEffect(() => {
    setPentaInner(processPenta(penta));
  }, [penta]);

  useEffect(() => {
    const languageParam = getHashParams(location.hash).get('ln');
    if (languageParam !== context.language && context.languages.includes(languageParam)) {
      context.setLanguage(languageParam);
    }
  }, [location]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleCloseInfoPop = () => {
    document.body.classList.remove('noscroll');
    context.setState.setHighlighted();
    context.setState.setSearch([]);

    const segments = location.pathname.split('/study');
    const newPath = segments.length > 1 ? segments[0] : null;
    if (newPath) navigate(newPath);
  };

  const isStudy = location.pathname.includes('study');
  const memberCount = pentaInner?.members?.length ?? 0;
  const pentaClass = [
    memberCount < 3 ? 'x_edu0--composite' : '',
    memberCount > 2 ? 'x_edu0--group' : '',
    isStudy ? 'x_edu0--study' : '',
  ].filter(Boolean).join(' ');

  return (
    <>
      <YoniBackground />

      <div className="yoni_page_container">
        {sharePop && (
          <Pop
            title={$ui('people_composite')}
            handleClose={() => setSharePop()}
          >
            <PentaShare penta={penta} handleClose={() => setSharePop()} />
          </Pop>
        )}

        <VideoPop />

        <div
          className={
            (!context.state.peoplePanel ? 'x_layout' : 'x_layout x_layout--people')
            + (isStudy ? ' x_layout--study' : '')
            + ' x_layout--yoni'
          }
          onClick={() => handleCloseInfoPop()}
        >
          <Topbar
            penta={pentaInner}
            mode2={scrolled}
            mode="yoni"
          />

          <Study
            penta={pentaInner}
            mode="yoni"
            handleClose={() => navigate('../')}
          />

          {Boolean(context.me) && (
            <Social
              hidePreviews={penta.members.length > 2}
              mode="yoni"
              showItems={['people', 'history', 'bodygraphs', 'pentas']}
            />
          )}
          {!Boolean(context.me) && <PublicSocial hidePreviews={penta.members.length > 3} />}

          {Boolean(penta) && penta.pentaDesign && (
            <div className="x_edu_c">
              <div className="l_panel">
                <div className={`x_edu0 ${pentaClass}`} ref={scrollable}>
                  <div className={!context.state.peoplePanel
                    ? 'x_edu_block x_edu_block--penta'
                    : 'x_edu_block x_edu_block--penta x_edu_block--open x_edu_block--penta'}
                  >
                    <div className="x_0_user">
                      <div className="x_0_user_block">
                        <div className="x_0_penta_avas">
                          <div className="x_calc_result_name0">
                            <div className="x_calc_result_name ">
                              <Avatar
                                onClick={() => void (0)}
                                penta={pentaInner}
                                type="calc"
                                tooltip={false}
                              />
                              <PentaName
                                penta={pentaInner}
                                flat={true}
                              />
                            </div>
                          </div>

                          {!Boolean(penta.token) && (
                            <Button
                              sm
                              iconDesktopOnly
                              icon="save"
                              labelMobileOff
                              iconMobileOnly
                              onClick={() => context.x.createPenta(
                                pentaInner.members.map(one => one.avatar.token),
                                (newPenta) => navigate(`/yoni/p/${newPenta.token}`)
                              )}
                            >
                              {$ui('penta_save_composite')}
                            </Button>
                          )}

                          <div className="x_penta_actions _f _fgap1 _fm">
                            {Boolean(pentaInner.token)
                              && penta.members.length > 1
                              && (
                                <Button
                                  ghost
                                  onClick={() => setSharePop(true)}
                                  icon="qr_code"
                                  labelMobileOff
                                >
                                  {$ui('but_public_link_short')}
                                </Button>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="x_edu_content00 x_penta_2cols x_edu_penta_persons0 x_edu_penta_persons0--yoni">
                      <PentaYoni
                        penta={pentaInner}
                        callback={(newPenta) => setPentaInner(processPenta(newPenta))}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
